export default function useElementFocus() {
  let focusElement = false;

  const focusElementHandler = () => {
    focusElement = true;
  };
  const blurElementHandler = () => {
    focusElement = false;
  };
  const isFocusElement = () => {
    if (focusElement) {
      focusElement = false;
      return true;
    }
    return false;
  };

  return { focusElementHandler, blurElementHandler, isFocusElement };
}
